import ProductForm from './_form'
import template from './new.pug'

export default Vue.extend({
  template: template(),
  components: {
    ProductForm
  },
  data() {
    return {
      errors: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('products.new.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.products.index'), route: {name: 'products-index'}},
      {label: this.$t('breadcrumbs.products.new'), route: {}}
    ])
  },
  methods: {
    createProduct(data) {
      API.products.create(data).then(() => {
        this.$notifications.success(this.$t('products.new.succesfullyCreated'))
        this.$router.push({name: 'products-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
